import React, { useEffect } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import TopSection from './TopCardOverview/TopSection';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getProjects } from '../../../redux/features/refundSlice';
import RefundProjectTable from './refundProjectTable/RefundProjectTable';
import SecondCardSections from './SecondCardSection/SecondCardSections';
import { Divider } from '@mui/material';
import ReasonOverview from './reasonOverView/ReasonOverview';
import RoleWiseRequest from './roleWiseReqeust/RoleWiseRequest';

const RefundAnalyticsLanding = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  return (
    <GlobalWrapper title={'Refund Overview'}>
      <TopSection />
      <Divider sx={{ my: 3 }} />
      <RefundProjectTable />
      <Divider sx={{ my: 3 }} />
      <SecondCardSections />
      <Divider sx={{ my: 3 }} />
      <ReasonOverview />
      <Divider sx={{ my: 3 }} />
      <RoleWiseRequest />
    </GlobalWrapper>
  );
};

export default RefundAnalyticsLanding;
